// Shared hero for all blog post pages — text-only, no video.
import Reveal from "./Reveal";

interface PostHeroProps {
  category: string;
  title: string;
  author: string;
  date: string;
  readTime: string;
  excerpt: string;
}

export default function PostHero({ category, title, author, date, readTime, excerpt }: PostHeroProps) {
  return (
    <section
      className="bg-black pt-40 pb-20 px-6 relative overflow-hidden"
      style={{ backgroundImage: "radial-gradient(ellipse at top, rgba(255,255,255,0.04) 0%, transparent 60%)" }}
    >
      <div className="max-w-3xl mx-auto">
        <Reveal kind="reveal-soft">
          <div className="liquid-glass rounded-full px-4 py-1.5 inline-flex text-white/70 text-xs tracking-widest uppercase mb-6">
            {category}
          </div>
        </Reveal>

        <Reveal delay={80}>
          <h1 className="font-instrument text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-[1.1]">
            {title}
          </h1>
        </Reveal>

        <Reveal delay={160}>
          <div className="flex items-center gap-4 mt-6 text-white/40 text-xs tracking-widest uppercase">
            <span>{author}</span>
            <span>·</span>
            <span>{date}</span>
            <span>·</span>
            <span>{readTime}</span>
          </div>
        </Reveal>

        <Reveal delay={240}>
          <p className="text-white/60 text-base md:text-lg leading-relaxed mt-6 max-w-2xl">
            {excerpt}
          </p>
        </Reveal>

        <div className="hairline mt-12" />
      </div>
    </section>
  );
}
